export enum VolumePace {
  LIGHT = 'LIGHT',
  BELOWAVG = 'BELOWAVG',
  AVG = 'AVG',
  ABOVEAVG = 'ABOVEAVG',
  HEAVY = 'HEAVY',
  UNKNOWN = 'UNKNOWN'
}

